import { render, staticRenderFns } from "./MeetingCommentDesktop.vue?vue&type=template&id=04fbbaa5&scoped=true"
import script from "./MeetingCommentDesktop.vue?vue&type=script&lang=js"
export * from "./MeetingCommentDesktop.vue?vue&type=script&lang=js"
import style0 from "./MeetingCommentDesktop.vue?vue&type=style&index=0&id=04fbbaa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbbaa5",
  null
  
)

export default component.exports